import React from 'react';
import { ConfigProvider as DesignProvider } from 'antd';
import { Colors } from '@turing/utils/colors';

interface IProps {
  children: React.ReactNode;
}

export const ConfigProvider = (props: IProps) => {
  const { children } = props;
  return (
    <DesignProvider
      theme={{
        token: {
          colorPrimary: Colors.Purple,
          colorBgContainerDisabled: Colors.PurpleDisabled,
          colorBorder: Colors.Transparent,
          colorTextDisabled: Colors.Grey60,
        },
      }}>
      {children}
    </DesignProvider>
  );
};
